import { format } from "date-fns";

const statuses = {
  NOT_STARTED: "Ej klar",
  IN_PROGRESS: "Klar för granskning",
  APPROVED: "Godkänd",
  NOT_ELIGIBLE: "Ej aktuell",
  SUBMITTED: "Inskickad",
  IN_REVIEW: "Under behandling",
  CONFIRMED: "Bekräftad"
};

export const statusName = status => {
  if (statuses[status]) {
    return statuses[status];
  }
  return status;
};

export const actionHasHadStatus = (action, status) => {
  const statusIndex = Object.keys(statuses).indexOf(status);
  if (statusIndex !== -1) {
    return Object.keys(statuses).indexOf(action.status) >= statusIndex;
  }
  return false;
};

export const actionIsNotDone = action => {
  return (
    !actionHasHadStatus(action, "APPROVED") && action.status !== "NOT_ELIGIBLE"
  );
};

export const sortingKeyOptions = () => {
  return [
    {
      value: "name",
      text: "Namn"
    },
    {
      value: "percentCompleted",
      text: "Färdigställande"
    },
    {
      value: "created",
      text: "Skapad"
    }
  ];
};

const actionTypes = {
  ATTACHMENT: "Bilaga",
  OTHER_REQUIREMENT: "Andra krav",
  GET_MEMBERINFO_FROM_TELLUS: "Hämta medlemsinfo från Tellus",
  SCHEDULE_EMAIL: "Schemalägg välkomstmail) "
};

export const actionTypeName = actionType => {
  if (actionTypes[actionType]) {
    return actionTypes[actionType];
  }
  return actionType;
};

export const actionName = action => {
  return action.name || actionTypeName(action.type);
};

export const actionStatusText = action => {
  switch (action.type) {
    case "ATTACHMENT":
      switch (action.status) {
        case "APPROVED":
          return "Dokumentet är godkänt.";
        case "IN_PROGRESS":
          if (action.attachmentUrl) {
            if (action.attachmentUrl) {
              return "Ett dokument är uppladdat och väntar på granskning.";
            }
          } else {
            return "Det uppladdade dokumentet är borttaget.";
          }
          return;
        case "NOT_STARTED":
          return "Inget dokument har laddats upp.";
      }
      break;
    case "OTHER_REQUIREMENT":
      return action.description;
    case "CONTACT":
      switch (action.status) {
        case "NOT_STARTED":
        case "IN_PROGRESS":
          return "Epost saknas för firmatecknare och/eller kontaktperson";
        case "APPROVED":
          return "Alla kontaktuppgifter är ifyllda";
      }
  }
  return "";
};
export const actionHandleAttachment = action => {
  if (action.type === "OTHER_REQUIREMENT") {
    return "Hantera krav";
  } else {
    return "Hantera";
  }
};

export const actionHasUnhandledUpload = action => {
  return (
    action &&
    action.TYPE === "ATTACHMENT" &&
    action.status === "IN_PROGRESS" &&
    action.attachmentUrl
  );
};

export const inquiryCreated = inquiry => {
  return format(new Date(inquiry.created), "YYYY-MM-DD");
};

export const inquiryFilter = (showArchive, filter) => {
  return inquiry => {
    if (showArchive !== (inquiry.phase === "ARCHIVED")) {
      return false;
    }
    if (filter.association && filter.association !== inquiry.association) {
      return false;
    }
    if (filter.phase && filter.phase !== inquiry.phase) {
      return false;
    }
    return true;
  };
};

export const inquiryComparer = sorting => {
  return (a, b) => {
    if (a[sorting.key] < b[sorting.key]) {
      return sorting.order === "ASC" ? -1 : 1;
    }
    if (a[sorting.key] > b[sorting.key]) {
      return sorting.order === "ASC" ? 1 : -1;
    }
    return 0;
  };
};
